import { render, staticRenderFns } from "./PackageManagementPage.vue?vue&type=template&id=05a0c31a"
import script from "./PackageManagementPage.vue?vue&type=script&lang=js"
export * from "./PackageManagementPage.vue?vue&type=script&lang=js"
import style0 from "./PackageManagementPage.vue?vue&type=style&index=0&id=05a0c31a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a0c31a')) {
      api.createRecord('05a0c31a', component.options)
    } else {
      api.reload('05a0c31a', component.options)
    }
    module.hot.accept("./PackageManagementPage.vue?vue&type=template&id=05a0c31a", function () {
      api.rerender('05a0c31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/PackageManagementPage.vue"
export default component.exports